import script from "./InfoActionBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoActionBox.vue?vue&type=script&setup=true&lang=js"

import "./InfoActionBox.vue?vue&type=style&index=0&id=654c90ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-654c90ad"]])

export default __exports__